import PropTypes from 'prop-types'
import InputWiz from '../../../../../../../common/inputs/wizard/InputWiz.jsx'
import { HeaderTitle } from '../../../../../../../common/HeaderTitle.jsx'

export const Start = (props) => {


    return (
        <>
            {/*<JsonViewer src={props.wiz?.form || {}} show={true} />*/}

            <HeaderTitle noHr size={'fs-3'} title={'Start'} />

            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź kluczowe informacje dotyczące planowanego harmonogramu projektu'}
            />

            <div className={'d-flex flex-column gap-3'}>
                <InputWiz wiz={props.wiz} disabled keyName={'numer'} />
                <InputWiz wiz={props.wiz} disabled keyName={'podmiot'} />
            </div>
        </>
    )
}

Start.propTypes = {
    wiz: PropTypes.any,
}
